const NaCommonKeys = {
    PENDING_AUTO_SEND: "pendingAutoSend",
    CBSA_RECEIVEDAND_PROCESSING: "cbsaReceivedAndProcessing",
    REGISTERED: "registered",
    PENDING: "pending",
    SEND_SUCCESSFULLY: "sendSuccessfully",
    REJECT_TYPE: "rejectType",
    FUNCTIONAL_ACNKOWLEDGEMENT_MESSAGE_RECEIVED: "functionalAcnkowledgementMessageReceived",
    ADMINISTRATION_ERROR: "administrationError",
    ENFORCEMENT_ERROR: "enforcementError",
    SYNTAX_ERROR: "syntaxError",
    RISK_ASSESSMENT: "riskAssessment",
    BATCH_ERROR: "batchError",
    DATA_ERROR: "dataError",
    SUPPLEMENTARY_MATCH_YES: "supplementaryMatchYes",
    SUPPLEMENTARY_MATCH_NO: "supplementaryMatchNo",
    CONVEYANCE_ARRIVED: "conveyanceArrived",
    ACCEPTED: "accepted",
    ACCEPTED_MATCHED: "acceptedMatched",
    MANIFEST_FORWARD: "manifestForward",
    REJECTED: "rejected",
    TEMPLATE: "template",
    CANCELLATION_ACCEPTED: "cancellationAccepted",
    CANCELLATION_REJECTED: "cancellationRejected",
    DRAFT: "draft",
    SN: "sn",
    SN_TRUCK_ARRIVED: "snTruckArrived",
    SN_GOODS_RELEASE: "snGoodsRelease",
    MODIFICATION_REJECTED: "modificationRejected",
    SENT: "sent",
    PRELIMINARY: "preliminary",
    CP: "cp",
    CANCEL: "cancel",
    REPLACE: "replace",
    CONFIRM: "confirm",
    SPL: "spl",
    ACCEPTED_WITH_WARNING: "acceptedWithWarning",
    SEND_FAILED: "sendFailed",
    PENDING_REVIEW: "pendingReview",
    REVIEW_IN_PROGRESS: "reviewInProgress",
    REVIEWED: "reviewed",
    USER_PASSWORD_EXPIRED_MSG: "userPasswordExpiredMsg",
    UPDATE_PASSWORD: "updatePassword",
    ADD: "add",
    ADD_NEW: "addNew",
    REMOVE_BUTTON: "removeButton",
    MANDATORY_FIELDS: "mandatoryFields",
    NO_RECORDS_MESSAGE: "noRecordsMessage",
    OK: "ok",
    ACTION: "action",
    ACCOUNT_NAME_AND_OR: "accountNameAndOr",
    HISTORY: "history",
    CONFIRMATION_MESSAGE: "confirmationMessage",
    CONFIRM_DISCARD: "confirmDiscard",
    CONTINUE_EDIT: "continueEdit",
    DATA_NOT_FOUND: "dataNotFound",
    SAVE_CHANGES: "saveChanges",
    RESET: "reset",
    SUBMIT: "submit",
    RESPONSE_LOG:"responseLog",
    DOWNLOAD : "download",
    SAVE : "save",
    DISCARD :  "discard",
    SAVE_AS_DRAFT: "saveAsDraft",
    UPDATE: "update",
    EDIT: "edit",
    DELETE: "delete",
    DELETE_CONFIRMATION_MSG: "deleteConfirmationMsg",
    DELETE_CONFIRM_BUTTON: "deleteConfirmButton",
    DELETE_CANCEL_BUTTON: "deleteCancelButton",
    DEACTIVATED: "deactivated"
}

export default NaCommonKeys